<template>
  <div class="hlb-refund" :aria-busy="loading">
    <div v-if="loading" class="hlb-refund-hint" role="status">合利宝退款结果查询中...</div>
    <div v-else-if="error" class="hlb-refund-error" role="alert">
      <span>合利宝退款结果查询失败：{{ error }}</span>
      <button v-if="tradeNo" type="button" class="hlb-refund-retry" @click="loadStatus">重试</button>
    </div>
    <div v-else-if="detail" :class="resultClass(detail.rt8_orderStatus)">
      合利宝：{{ statusText(detail.rt8_orderStatus) }}<span v-if="detail.retReason"> · {{ detail.retReason }}</span>
    </div>
  </div>
</template>

<script>
import { getHelibaoRefundStatus } from "@/utils/userQueryApi";
import { parseHelibaoRefundStatus } from "@/utils/helibaoRefund";

export default {
  name: "HelibaoRefundStatus",
  props: {
    tradeNo: { type: [String, Number], default: "" },
  },
  data() {
    return { loading: false, error: "", detail: null, requestId: 0 };
  },
  watch: {
    tradeNo: {
      immediate: true,
      handler() {
        this.loadStatus();
      },
    },
  },
  beforeUnmount() {
    this.requestId += 1;
  },
  methods: {
    async loadStatus() {
      const requestId = ++this.requestId;
      const tradeNo = String(this.tradeNo ?? "").trim();
      this.detail = null;
      this.error = "";
      this.loading = false;
      if (!tradeNo) {
        this.error = "缺少付款订单号";
        return;
      }
      this.loading = true;
      try {
        const response = await getHelibaoRefundStatus(tradeNo);
        if (requestId !== this.requestId) return;
        this.detail = parseHelibaoRefundStatus(response);
      } catch (error) {
        if (requestId !== this.requestId) return;
        this.error = error?.message || "网络异常，请稍后重试";
      } finally {
        if (requestId === this.requestId) this.loading = false;
      }
    },
    statusText(status) {
      if (status === "SUCCESS") return "退款成功";
      if (status === "FAILED") return "退款失败";
      return status ? `退款状态：${status}` : "退款状态待确认";
    },
    resultClass(status) {
      if (status === "SUCCESS") return "hlb-refund-success";
      return status === "FAILED" ? "hlb-refund-error" : "hlb-refund-hint";
    },
  },
};
</script>

<style scoped>
.hlb-refund {
  font-size: 12px;
  overflow-wrap: anywhere;
}
.hlb-refund-hint { color: #6b6966; }
.hlb-refund-success { color: #2d6a2e; }
.hlb-refund-error { color: #a63a32; }
.hlb-refund-retry {
  margin-left: 6px;
  padding: 2px 6px;
  border: 1px solid #d0ccc5;
  border-radius: 4px;
  background: #fff;
  color: #37352f;
  font: inherit;
  cursor: pointer;
}
.hlb-refund-retry:hover { background: #f0efed; }
.hlb-refund-retry:focus-visible { outline: 2px solid #2878b5; outline-offset: 2px; }
</style>
